// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import Vuex from 'vuex';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './vuex/store';
import util from '@/assets/js/util';
import '@/assets/scss/global.scss';
import VueClipboard from 'vue-clipboard2';
import QRCode from 'qrcodejs2';
import BayesHeadTop from '@/components/BayesHeadTop.vue';
import EasyAdsHeadTop from '@/components/EasyAdsHeadTop.vue';
import Ads from 'vue-google-adsense';

Vue.use(ElementUI);
Vue.use(Vuex);
Vue.use(util);
Vue.use(VueClipboard);

Vue.use(require('vue-script2'))

Vue.use(Ads.Adsense);
Vue.use(Ads.InArticleAdsense);
Vue.use(Ads.InFeedAdsense);

Vue.component("bayes-head-top", BayesHeadTop);
Vue.component("easyads-head-top", EasyAdsHeadTop);

Vue.config.productionTip = false;
Vue.prototype.$qrCode = QRCode;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js